import { render, staticRenderFns } from "./DialogAddEditSession.vue?vue&type=template&id=10986423&scoped=true"
import script from "./DialogAddEditSession.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditSession.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10986423",
  null
  
)

export default component.exports